import * as React from "react";

import { cn } from "src/utils/cn";

function Card({ className, ...props }) {
  return (
    <div
      className={cn(
        "rounded-3xl border border-white/10 bg-slate-900/70 shadow-2xl backdrop-blur-xl",
        className
      )}
      {...props}
    />
  );
}

function CardHeader({ className, ...props }) {
  return <div className={cn("space-y-2 p-6 sm:p-8 lg:p-10", className)} {...props} />;
}

function CardTitle({ className, ...props }) {
  return <h2 className={cn("text-3xl font-semibold text-white", className)} {...props} />;
}

function CardDescription({ className, ...props }) {
  return <p className={cn("text-sm text-slate-400", className)} {...props} />;
}

function CardContent({ className, ...props }) {
  return <div className={cn("p-6 pt-0 sm:p-8 sm:pt-0 lg:p-10 lg:pt-0", className)} {...props} />;
}

export { Card, CardHeader, CardTitle, CardDescription, CardContent };
